<svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M68.5 68.5L18.5 68.5C9.66344 68.5 2.5 61.3366 2.5 52.5L2.49999 2.5" stroke="white" stroke-width="5" stroke-linecap="square"/>
</svg>
